export type FavoriteType = 'claim' | 'tow-request';
const KEY = 'itow.preferences.favorites';

function read(): Record<string, true> {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch { return {}; }
}

export function isFavorite(type: FavoriteType, id: number): boolean {
  return read()[`${type}:${id}`] === true;
}

export function getFavoritesCount(): number {
  return Object.keys(read()).length;
}

export function toggleFavorite(type: FavoriteType, id: number): boolean {
  const map = read();
  const key = `${type}:${id}`;
  const next = { ...map };
  if (next[key]) delete next[key];
  else next[key] = true;
  // localStorage may be unavailable (private browsing quota exceeded); silently swallow.
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch { /* intentional no-op */ }
  // Notify same-tab listeners (storage event only fires in *other* tabs).
  window.dispatchEvent(new Event('itow-favorites-changed'));
  return next[key] === true;
}
